(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  function updateAnnouncementHeight() {
    const bar = document.getElementById("announcement-bar");
    const nav = document.querySelector("nav.main-nav");

    if (bar && bar.style.display !== "none") {
      document.body.style.setProperty("--announcement-bar-height", bar.offsetHeight + "px");
      document.body.classList.add("is-announcement-bar");
    } else {
      document.body.style.setProperty("--announcement-bar-height", "0px");
      document.body.classList.remove("is-announcement-bar");
    }

    if (nav) {
      document.body.style.setProperty("--announcement-bar-nav-height", nav.offsetHeight + "px");
    }
  }

  function handleAnnouncementScroll() {
    if (window.scrollY > 100) {
      document.body.classList.add("announcement-bar-scrolled");
    } else {
      document.body.classList.remove("announcement-bar-scrolled");
    }
  }

  function initAnnouncementBar() {
    const bar = document.getElementById("announcement-bar");
    const slider = document.getElementById("announcement-bar-slider");
    const closeButton = document.getElementById("announcement-bar-close");

    if (!bar) return;

    if (slider && typeof Swiper !== "undefined" && !slider.classList.contains("swiper-initialized")) {
      new Swiper("#announcement-bar-slider", {
        effect: "fade",
        speed: 800,
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        autoplay: {
          delay: 3000,
        },
        allowTouchMove: false,
      });
    }

    updateAnnouncementHeight();
    handleAnnouncementScroll();

    closeButton?.addEventListener("click", () => {
      bar.style.display = "none";
      updateAnnouncementHeight();
    });

    window.addEventListener("resize", updateAnnouncementHeight);
    window.addEventListener("scroll", handleAnnouncementScroll);
  }

  initAnnouncementBar();
  document.addEventListener("shopify:section:load", initAnnouncementBar);
  document.addEventListener("shopify:section:reorder", initAnnouncementBar);
  document.addEventListener("shopify:block:select", initAnnouncementBar);

  } catch(e) { console.error(e); }
})();
})();
